import Immutable from 'immutable';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ContactForm from '../common/ContactForm';
import { withTranslation } from "react-i18next";

import { isEmailSending, isEmailSent, resetEmail } from './redux/selectors';

import { Container, Header, Segment, Dimmer, Loader, Icon, Button } from 'semantic-ui-react'





export class ContactUsNoTranslation extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };


  // state = { activeEmailSent: false }

  handleClose = () => {
    console.log("close dimmer!!!");
    this.props.actions.resetEmailSent();
  }
  onSubmitMessage = (emailInfo) => {
    // console.log('Info to submit', emailInfo.toJSON());
    const emailInfoJson = emailInfo.toJSON();
    // email: "fernando.guardiola.888@gmail.com", message: "axaxxx"
    // Send email
    const templateId = 'template_hmAhdKHw';
    // this.sendFeedback(templateId, {message_html: emailInfoJson.message, from_name: emailInfoJson.email, reply_to: 'oripandohostel@gmail.com'})
    // debugger;
    // console.log(actions.sendEmail);
    this.props.actions.sendEmail(templateId, { message_html: emailInfoJson.message, from_name: emailInfoJson.email, reply_to: 'oripandohostel@gmail.com' })
  }
  render() {


    const { t } = this.props;

    const { isSending, isSent } = this.props;
    // const { active } = this.state
    // const  isSending = true;      
    return (
      <div className="home-contact-us">
        {
          !isSending && !isSent && <Container className="contact-us-form">
            <Header as="h1" className="contact-us-header">{t('contactForm.title', { framework: 'React' })}</Header>
            <ContactForm onSubmitInfo={this.onSubmitMessage} />
          </Container>
        }
        {
          isSending && <Container className="contact-us-spinner">
            {/* <Loader inverted className='loader-sending-emal'>Loading....</Loader> */}
            <Segment className='loader-sending-email'>
              <Dimmer active inverted>
                <Loader size='massive'>{t('contactForm.sending', { framework: 'React' })}</Loader>
              </Dimmer>
            </Segment>
          </Container>
        }
        {
          !isSending && isSent && <Container className="contact-us-spinner">
            {/* <Loader inverted className='loader-sending-emal'>Loading....</Loader> */}
            <Segment className='loader-sending-email'>

              <Dimmer active onClickOutside={this.handleClose} page>
                <Header as='h2' icon inverted>
                  <Icon name='checkmark' />
                  {t('general.sendEmailDimmerHeader', { framework: 'React' })}
                  <Header.Subheader>
                    <Button className='close-button' primary onClick={this.handleClose}>{t('general.sendEmailDimmerSubHeader', { framework: 'React' })}</Button>
                  </Header.Subheader>

                </Header>
              </Dimmer>
            </Segment>


          </Container>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
    isSending: isEmailSending(state),
    isSent: isEmailSent(state),
    rEmail: resetEmail(state)
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}
const ContactUs = withTranslation('common')(ContactUsNoTranslation)


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactUs);



// WEBPACK FOOTER //
// ./src/features/home/ContactUs.js